// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1JLZJ","content":"LayoutSettings_content__985RB"};